import React, { useEffect, useState } from 'react'
import NewCommunityItem from './NewCommunityItem'
import general, { redux } from '../../general';
import Dialog from '../../lib/Dialog';
import './css/NewCommunity.css'
import { NavLink } from '../../lib/Navigation';

export default function NewCommunity(props) {

  const { active } = props;

  const [own, setOwn] = useState([])
  const [hot, setHot] = useState([])
  const isMainCommunity = props.isMainCommunity ? props.isMainCommunity : false;
  const [activeIndex, setActiveIndex] = useState(0)
  const [activeItem, setActiveItem] = useState()
  const [scrollTop, setScrollTop] = useState(0)
  const [isOwn, setIsOwn] = useState(null)
  const [init, setInit] = useState(false)
  const [messageUnreadNum, setMessageUnreadNum] = useState(0)

  const community_rooftop = () => {
    Dialog.loading()
    general.axios.post('/community_rooftop')
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status, data: { topranked_games, recommend_circles_games } } = res.data;
        if (status.succeed) {
          setIsOwn(topranked_games.length > 0)
          setOwn(topranked_games)
          setHot(recommend_circles_games)
          setInit(true)
          setActiveIndex(0)
        }
      })
  }

  const getBenefitEvents = () => {
    if (activeIndex >= own.length && isOwn) {
      return
    }
    general.axios.post('/getBenefitEvents', {
      circles_type: props.query?.topic_id ? props.query?.circles_type : (isOwn && own.length > 0 ? own[activeIndex].type : hot[activeIndex].type),
      topic_id: props.query?.topic_id ? props.query.topic_id : (isOwn && own.length > 0 ? own[activeIndex].maiyou_gameid : hot[activeIndex].maiyou_gameid),
    })
      .then(res => {
        const { status, data } = res.data;
        if (status.succeed) {
          setActiveItem(data)
          if (props.handleInit) {
            props.handleInit()
          }
        }
      })
  }

  useEffect(() => {
    if (init) {
      getBenefitEvents()
    }
  }, [activeIndex, init, isOwn, own])

  useEffect(() => {
    if (active && !init) {
      if (props.query?.topic_id) {
        getBenefitEvents()
      } else {
        community_rooftop()
      }

      redux.subscribe(() => {
        let topranked_games = redux.getState().topranked_games;
        if (topranked_games) {
          community_rooftop()
          setTimeout(() => {
            const div = document.getElementsByClassName("community-header-container")[0]
            div.scrollTo({
              left: 0,
              behavior: 'smooth'
            });
          }, 1000);
        }
      })
    }
  }, [active, init])

  const messUnreadCount = () => {
    general.axios.post('/getUnreadNumberMess')
      .then(res => {
        let { status, data } = res.data;
        if (!status.succeed) {
          return;
        }
        setMessageUnreadNum(data.community_unread_num);
      })
  };

  useEffect(() => {
    if (active && !isMainCommunity) {
      messUnreadCount()
      props.setOperate(<div style={{ display: 'flex', alignItems: 'center' }}>
        <NavLink user={false} to={'/community/search?circles_type=' + activeItem?.circles_type + '&topic_id=' + (activeItem?.maiyou_gameid || '')} style={{ display: 'flex', alignItems: 'center' }}>
          <img src="resources/251009/search.png" alt="" height={15} />
        </NavLink>
        <NavLink to="/message/list?type=community" style={{ paddingLeft: 15, fontSize: 14, color: 'white', position: 'relative' }}>
          <div>消息</div>
          {messageUnreadNum > 0 && <div style={{ position: 'absolute', top: -1, right: -3, backgroundColor: '#FC263F', width: 5, height: 5, borderRadius: 2.5 }}></div>}
        </NavLink>
      </div>)
    }
  }, [active, isMainCommunity, messageUnreadNum]);

  return (
    <div className='community-page-index'>
      <NewCommunityItem
        own={own}
        hot={hot}
        isOwn={isOwn}
        prefix={props.prefix ? props.prefix : ''}
        active={active}
        isMainCommunity={isMainCommunity}
        activeItem={activeItem}
        handleActiveIndex={e => setActiveIndex(e)}
        handleIsOwn={e => setIsOwn(e)}
        onScroll={scroll => {
          setScrollTop(scroll.top)
          if (props.setTitle) {
            props.setTitle(scroll.top > 40 ? <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={activeItem?.bgicon} alt="" height={26} width={26} />
              <div style={{ color: 'white', fontSize: 17, fontWeight: 500, paddingLeft: 10 }}>{activeItem?.game_name}</div>
            </div> : '')
          }
        }}
      ></NewCommunityItem>
    </div>
  )
}
